import React from "react";

import { Button } from "antd";
import { ISeatDetail, ITripDetail } from "../../../../models/trip";
import ButtonAddSeat from "../button/ButtonAddSeat";
import { removeSeatApi } from "../../../../apis/seat.api";
import { ConfirmPopup, ErrorPopup } from "../../../../utilities/swal";
import ButtonRemoveSeat from "../button/ButtonRemoveSeat";

interface ActionBarProps {
  selectedSeats: ISeatDetail[];
  onConfirm: () => void;
  onCancel: () => void;
  selectMode: string | null;
  setBusIdChanged: React.Dispatch<React.SetStateAction<string[]>>;
  onSetTrip: React.Dispatch<React.SetStateAction<ITripDetail | null>>;
}

const ActionBar: React.FC<ActionBarProps> = (props: ActionBarProps) => {
  const {
    selectedSeats,
    onCancel,
    selectMode,
    onConfirm,
    setBusIdChanged,
    onSetTrip,
  } = props;
  const isVisible = selectedSeats.length > 0;

  const updateSeats = (newSeats: ISeatDetail[]) => {
    onSetTrip((prev) => {
      if (!prev) return prev;

      let hasError = false;

      const updatedTrip = {
        ...prev,
        buses: prev.buses.map((bus) => {
          const seatsForBus = newSeats.filter((seat) => seat.busId === bus._id);

          if (seatsForBus.length === 0) return bus; // bus không có seat cần update

          const seatMap = new Map(bus.seats.map((s) => [s._id, s])); // seat cũ của bus

          // Kiểm tra seat nào không tồn tại → báo lỗi
          seatsForBus.forEach((seat) => {
            if (!seatMap.has(seat._id)) {
              console.error(
                `Seat ${seat._id} không tồn tại trong bus ${bus._id}`
              );
              hasError = true;
            }
          });

          // Nếu có lỗi → không update bus này
          if (hasError) return bus;

          // Không có lỗi → cập nhật seat
          const updatedSeats = bus.seats.map(
            (seat) => seatsForBus.find((s) => s._id === seat._id) || seat
          );

          return {
            ...bus,
            seats: updatedSeats,
          };
        }),
      };

      // Nếu có lỗi → KHÔNG update trip (return prev)
      if (hasError) {
        console.warn("Có seat không tồn tại → KHÔNG cập nhật trip.");
        return prev;
      }

      return updatedTrip;
    });
  };
  return (
    <div
      className={`fixed left-1/2 transform -translate-x-1/2 w-[95%]  max-w-lg p-2 z-50 transition-all duration-300
        ${
          isVisible
            ? "bottom-5 opacity-100 translate-y-0"
            : "-bottom-20 opacity-0 translate-y-10"
        }
      `}
    >
      <div className="flex justify-between items-center bg-white shadow-2xl backdrop-blur-sm px-3 py-2 rounded-xl border border-gray-200">
        {/* Thông tin ghế đã chọn */}
        <div className="text-gray-800 mb-2 md:mb-0">
          <p className="text-base font-medium">
            Đã chọn {selectedSeats.length} ghế :
          </p>
          <p className="text-blue-600 text-lg font-bold">
            {selectedSeats?.map((s) => s.seatCode).join(", ")}
          </p>
        </div>
        <div className="flex gap-2">
          {selectMode === "add" && (
            <ButtonAddSeat
              selectedSeats={selectedSeats}
              busId={selectedSeats[0]?.busId}
              tripId={selectedSeats[0]?.tripId}
              onSuccess={(value: ISeatDetail[]) => {
                updateSeats(value);
                onConfirm();
              }}
            />
          )}

          {selectMode === "edit" && (
            <>
              {/* <Button type="primary">Đổi chỗ</Button> */}
              <ButtonRemoveSeat
                selectedSeats={selectedSeats}
                onSuccess={(value: ISeatDetail[]) => {
                  updateSeats(value);
                  onConfirm();
                }}
              />
            </>
          )}

          <Button type="default" size="large" onClick={onCancel}>
            Bỏ chọn
          </Button>
        </div>{" "}
      </div>
    </div>
  );
};

export default ActionBar;
